/* eslint-disable prettier/prettier */
const API_HOST = process.env.VUE_APP_URL;

const FILE_ROOT = process.env.VUE_FILE_ROOT;
const URL_CONST = {
  /////////////////////////////////////////////////////////////////////////////
  // 공통
  /////////////////////////////////////////////////////////////////////////////
  GET_FILE_URL: API_HOST + FILE_ROOT,                                               // 파일 업로드 URL ROOT 
  FILE_UPLOAD: API_HOST + "/api/file/uploadFiles.do",                               // uploadFiles, fileCtgCd, fileBizId
  FILE_DOWN_LOAD: API_HOST + "/api/file/fileDownload.do",                           // FILE_DOWN_LOAD?fileBaseId=""  or ( ?fileCtgCd=""&fileBizId="" )
  FILE_DOWN_LOAD_HP: API_HOST + "/api/file/fileDownloadOfHomepage.do",                           // FILE_DOWN_LOAD?fileBaseId=""  or ( ?fileCtgCd=""&fileBizId="" )
  GET_COMMON_CODE_LIST: API_HOST + "/api/cmm/getComboCodeList.do",
  GET_COMBO_BOX_CODE_LIST: API_HOST + "/api/cmm/getSelectBoxComboCodeList.do",
  EXCEL_FILE_UPLOAD: API_HOST + "/api/cmm/excelUpload.do",
  GET_AUTH_MENU_LIST: API_HOST + "/api/auth/getAuthMenuList.do",                    // 파라메터 : {}  -- header의 token에서 userNo 추출하여 조회  
  GET_COMPANY_LIST: API_HOST + "/api/cmm/getCompanyList.do",
  ADD_COMPANY: API_HOST + "/api/cmm/addCompany.do",
  ////////////////////////////////////////////////////////////////////////////
  // 교우/임원단 관리
  ///////////////////////////////////////////////////////////////////////////

  // 교우조회 ////////////////////////////////////////////////////////////////
  GET_MEMBER_LIST: API_HOST + "/api/aln/getMemberList.do",
  GET_MEMBER_LIST2: API_HOST + "/api/aln/getMemberList2.do",
  MEMBER_EXCEL_DOWNLOAD: API_HOST + "/api/aln/excelDownload.do",
  
  GET_LABEL_LIST: API_HOST + "/api/aln/getMemberLabelList.do",
  LABEL_EXCEL_DOWNLOAD : API_HOST + "/api/aln/labelExcelDownload.do",
  
  // 교우관리 ///////////////////////////////////////////////////////////////
  // 직장,주소,회비 이력 : K0003122 - 김민희, K0003285 - 김병국, K0006641 - 김병철, K0014111 - 김남용
  // 직장,주소,회비, 상담 이력 : K0001534 - 박세환환 K0057241 - 조형식, K0003908 - 김상신
  GET_SCHOLAR_LIST: API_HOST + "/api/aln/getScholarList.do",  // 학력사항
  SAVE_SCHOLAR: API_HOST + "/api/aln/saveScholar.do",
  UPDATE_SCHOLAR: API_HOST + "/api/aln/updateScholar.do",
  DELETE_SCHOLAR: API_HOST + "/api/aln/removeScholar.do",

  SAVE_MEMBER: API_HOST + "/api/aln/saveMember.do",
  SAVE_MEMBER_ADDR: API_HOST + "/api/aln/saveMemberAddr.do",
  SAVE_NEW_MULTI_MEMBER: API_HOST + "/api/aln/saveNewMemberBatchList.do",
  SAVE_NEW_MULTI_MEMBER2: API_HOST + "/api/aln/saveNewMemberBatchList2.do",
  SAVE_MEMBER_BATCH: API_HOST + "/api/aln/saveMemberBatch.do",
  DELETE_MEMBER: API_HOST + "/api/removeMember.do",
  GET_MEMBER_EMAIL_LIST: API_HOST + "/api/opr/getMemberEmailList.do",
  EMAIL_LIST_EXCEL_DOWNLOAD : API_HOST + "/api/opr/memberEmailExcelDownload.do",
  GET_WORK_HIS_LIST: API_HOST + "/api/cmm/getWorkHisList.do",     // 직장이력
  SAVE_WORK_HIS: API_HOST + "/api/cmm/saveWorkHis.do",            // 직장저장
  GET_ADDR_HIS_LIST: API_HOST + "/api/cmm/getAddrHisList.do",     // 주소이력
  SAVE_ADDR_HIS: API_HOST + "/api/cmm/saveAddrHis.do",            // 주소저장
  GET_FEE_LIST: API_HOST + "/api/due/getFeeList.do",              // 회비이력

  GET_CONSULT_HIS_LIST: API_HOST + "/api/aln/getConsultHisList.do",       // 상담이력
  GET_ORG_HIS_LIST: API_HOST + "/api/aln/getOrgHisList.do",               // 임원이력
  GET_DONATION_LIST: API_HOST + "/api/aln/getSchaDonationList.do",     // 기부금(장학)
  GET_BENEFIT_DONATION_LIST: API_HOST + "/api/aln/getBenefitDonationList.do",   // 장학금수혜목록

  GET_RELATIONS_LIST: API_HOST + "/api/aln/getRelationsList.do",          // 가족 교우
  SAVE_RELATIONS: API_HOST + "/api/aln/saveRelations.do",                 // 가족교우저장 : mMemberNo - 마스터의 memberNo, sMemberNo - 추가할 가족/교우, relCd - 선택한 관계
  DELETE_RELATIONS: API_HOST + "/api/aln/deleteRelations.do",

  UPDATE_MEMBER_BATCH: API_HOST + "/api/aln/modifyMemberBatchList.do", // "memberNo" : "K0000006", "homeGb" : "1", "homeZipcd" : "11111", "homeAddress1" : "test Addr1111", "homeAddress2" : "test Addr2222", "cellular":"12312341234", "eMail":"test@naver.com"
  //GET_PRIZE_LIST: API_HOST + "/api/scs/getPrizeList.do",                        // 포상내역 : K0104961, K0107256
  GET_EVENT_JOINER_LIST: API_HOST + "/api/aln/getEventJoinerInfoList.do",       // 행사참여내역

  GET_MEDICAL_CARD_PRT_LIST: API_HOST + "/api/hpg/getMedicalCardPrintList.do",  // 의료우대증출력목록

  SAVE_CONSULT: API_HOST + "/api/cst/saveConsult.do",            // 상담내역저장 : parameter - callId, memberNo, consult1Cd, consult2Cd, consultDesc
                                                                 // callId는 상담이력 조회시 그리드에 hidden으로 들고 있다가 저장시 넘겨주시면 됩니다.
                                                                 // 신규(이력이 없는 경우)인 경우는 callId = '00000000'으로 넘겨 주세요
  SAVE_PHOTO_FILES: API_HOST + "/api/file/uploadPhotoFiles.do",
  GET_ADDR_INFO: API_HOST + "/api/aln/getMember2Info.do",        //주소저장후 재조회
  SAVE_RESIGN: API_HOST + "/api/aln/saveResign.do",              // 퇴사처리

  
  DELETE_WORK_INFO: API_HOST + "/api/aln/delete_work_info.do",  // {memberNo} 파라메터로 입력받아, tb_member2 직장을 퇴사처리
  
  // 임원단관리 ////////////////////////////////////////////////////////////////////
  GET_ORG_LIST: API_HOST + "/api/aln/getOrgList.do",
  GET_ORG_RECORD_LIST: API_HOST + "/api/aln/getOrgRecordList.do",
  SAVE_ORG_LIST: API_HOST + "/api/aln/saveOrgList.do",
  SAVE_ORG: API_HOST + "/api/aln/saveOrg.do",
  UPDATE_ORG: API_HOST + "/api/aln/updateOrg.do",
  DELETE_ORG: API_HOST + "/api/aln/deleteOrg.do",
  ORG_EXCEL_DOWNLOAD: API_HOST + "/api/aln/excelDownloadOrg.do",


  // 교원관리 ////////////////////////////////////////////////////////////////////
  GET_SCHOOL_TEACHER_LIST: API_HOST + "/api/aln/getSchoolTeacherList.do",
  UPDATE_SCHOOL_TEACHER_INFO: API_HOST + "/api/aln/updateSchoolTeacherInfo.do",


  // 우편물 반송처리 ////////////////////////////////////////////////////////////
  GET_BACKPOST_LIST: API_HOST + "/api/cmm/getBackpostList.do",                             // 반송우편물조회  "status" : "1" 값으로 전송
  SAVE_BACKPOST_LIST : API_HOST + "/api/cmm/saveBackpost.do",         // 반송데이타 반송저 : "memberNo" : "K1111111", "postFlag":"01","loadDate":"20201212" 형식
  SAVE_BACKPOST_STATUS_LIST : API_HOST + "/api/cmm/saveBackpostList.do",         // 반송데이타 반송저 : "memberNo" : "K1111111", "postFlag":"01","loadDate":"20201212" 형식
  UPDATE_BACKPOST_STATUS_LIST : API_HOST + "/api/cmm/updateStatusCdBackpostList.do",  // [{"seqNo","memberNo"},{}]GET_BACKPOST_LIST에서 받은 값을 활용하여 배열 전송
  DELETE_BACKPOST_LIST : API_HOST + "/api/cmm/removeBackpostList.do",  // [{"seqNo","memberNo"},{}]GET_BACKPOST_LIST에서 받은 값을 활용하여 배열 전송
  BACKPOST_EXCEL_DOWNLOAD: API_HOST + "/api/cmm/excelDownloadBackpost.do",

  // 졸업회수관리 ////////////////////////////////////////////////////////////
  // 검색 : GET_MEMBER_LIST 재사용 : 졸업년월 - 201003 형태로 넘기셔야 합니다.
  UPDATE_GRADUATION_NO: API_HOST + "/api/aln/updateGraduationNo.do",                       // parameter : collegeCd, classCd, graduationYm, graduationNo


  ////////////////////////////////////////////////////////////////////////////
  // 회비 관리
  ///////////////////////////////////////////////////////////////////////////

  // 회비개별처리 : mockup-data>menu_2-1.js 파일에 호출 및 결과 있습니다. ///////////////////////////////////////////////////////////
  // 교우검색 : 교우관리의 교우검색 팝업 재사용
  // 납부상세내역 : 1-2메뉴의 GET_FEE_LIST 재사용
  GET_TOTAL_FEE_INFO: API_HOST + "/api/due/getTotalMemberFeeInfo.do",         // 납부내역요약 : K0000044
  SAVE_FEE: API_HOST + "/api/due/saveFee.do",                                 // 회비저장
  UPDATE_FEE: API_HOST + "/api/due/updateFee.do",                             // 회비변경
  DELETE_FEE: API_HOST + "/api/due/removeFee.do",
  SAVE_FEE_OCR_LIST: API_HOST + "/api/due/saveFeeOcrList.do",// 회비삭제

  // 회비일괄처리 : K0000054 ////////////////////////////////////////////////////////////
  // 기존에 작동하던 내용이었으나, 현재 그리드로 return type 변환하여 재 매핑 필요
  // grid로 변경 적용 해야합니다.
  // getMemberList.do 호출시 actionMode - 제거(앞으로 actrionMode가 있는 경우는 모두 제거하세요)
  // memberNoStr : 회원번호여러개조회시 memberNo|memberNo|.... 형태의 회원번호
  // 실행 : GET_MEMBER_LIST 1-1 교우조회 재사용
  SAVE_FEE_LIST : API_HOST + "/api/due/saveFeeList.do",                       //

  // 회비통계
  GET_STICS_FEE_HAKBUN_LIST : API_HOST + "/api/due/getStatisticsFeeOfHakbunList.do",
  GET_STICS_FEE_COLLEGE_LIST : API_HOST + "/api/due/getStatisticsFeeOfCollegeList.do",
  // 단체회비처리 : K0000054 ////////////////////////////////////////////////////////////

  // 2-3, 단체회비처리

  GET_BRANCH_FEE_LIST: API_HOST + "/api/grp/getBranchFeeList.do",         // 단체회비 내역조회
  SAVE_BRANCH_FEE : API_HOST + "/api/grp/saveBranchFee.do",         // 단체회비 내역 신규저장, 내역 수정
  DELETE_BRANCH_FEE : API_HOST + "/api/grp/deleteBranchFee.do",         // 단체회비 내역 삭제
  GET_BRANCH_MEMBER_LIST : API_HOST + "/api/grp/getBranchMemList.do",         // 단체 회원 조회, branchId, feeDate, feeTime을 함께 던져서 호출
  GET_BRANCH_MEMBER_LIST2 : API_HOST + "/api/grp/getBranchMemList2.do",         // 단체 회원 조회, branchId, feeDate, feeTime을 함께 던져서 호출
  
  INSERT_BRANCH_MEMBER_FEE: API_HOST + "/api/due/saveFeeList.do",         // 납부처리, 배열로 전송
  DELETE_BRANCH_MEMBER_FEE: API_HOST + "/api/due/removeFeeList.do",         // 미납처리, 배열로 전송

  // 2-4. 회비납부내역,  하나의 파일로 4개 탭 모두 구성
  GET_FEE_LIST_TOTAL : API_HOST + "/api/due/getFeeListTotalInfo.do",
  FEE_LIST_EXCEL_DOWNLOAD : API_HOST + "/api/due/excelDownload.do",
  
  // parameter없을 때, 첫번째 탭
  // parameter "feeGb" : "01", 2번째 탭
  // parameter "feeGb" : "02", 3번째 탭, 
  // parameter "feeCd" : "12", 4번째 탭, 배열 hakbunStr중 feeway 행과 orgNm 에 의해 테이블 구분

  // 2번째 탭 하단 grid는 기존 // 납부상세내역 : 1-2메뉴의 GET_FEE_LIST 재사용, "feeWay" : "{숫자}" 옵션으로 호출하시면 됩니다.
  // 3번째 탭 하단 grid는 GET_FEE_LIST_TOTAL의 결과 하단에 grid용 contents 가 존재함.
  // 4번째 탭 하단 grid는
  GET_ORG_FEE_LIST : API_HOST + "/api/due/getOrgFeeList.do",       // 에 "levelCd" : "{숫자}" 로 호출하면 됨. 

  // 2-7. 납부회수 등급관리
  //GET_MEMBER_LEVEL_LIST : "/api/aln/getMemberList.do",  //.
  GET_MEMBER_FEE_CNT_LIST : API_HOST + "/api/aln/getMemberFeeCntList.do",  // 파라미터 "levelCd":"01","memberGb":"N","feeCountFrom":0,"feeCountTo":10,"mlevelCd" : ""
  UPDATE_MEMBER_LEVEL_LIST : API_HOST + "/api/aln/modifyMlevelCdList.do",      // memberNo, mlevelCd를 배열로 보내는 API
  PAYMENT_EXCEL_DOWNLOAD : API_HOST + "/api/aln/MemberFeeCntExcelDownload.do",


  //3-1. 단체관리 > 단체목록
  GET_BRANCH_LIST: API_HOST + "/api/grp/getBranchList.do",         // 단체목록, 조건, branchId, branchNm(단체명),branchGb(구분), memberHnm(발송교우명),
  SAVE_BRANCH : API_HOST + "/api/grp/saveBranch.do",         // 단체 내역 신규저장, branchGb(구분)을 필수값으로 나머지 정보 저장.
  UPDATE_BRANCH : API_HOST + "/api/grp/updateBranch.do",         // 단체 내역 수정, branchId, branchGb(구분) 2 항목을 필수값으로 나머지 정보 저장.
  DELETE_BRANCH : API_HOST + "/api/grp/deleteBranch.do",         // 단체 삭제, 필수값 branchId
  BRANCH_EXCEL_DOWNLOAD: API_HOST + "/api/grp/branchListExcelDownload.do",
  BRANCH_MEMBER_EXCEL_DOWNLOAD: API_HOST + "/api/grp/branchMemberListExcelDownload.do",
  // 단체 회원 조회, 2-3. GET_BRANCH_MEMBER_LIST 재사용, 조건 parameter, branchId,  함께 던져서 호출

  SAVE_BRANCH_MEMBER : API_HOST + "/api/grp/saveBranchMemList.do",         //     "branchId": "B00003", "memberNo": "K0000008" 형식으로 값 전송
  DELETE_BRANCH_MEMBER: API_HOST + "/api/grp/deleteBranchMemList.do",      //     "branchId": "B00003", "memberNo": "K0000008" 형식으로 값 전송
  
  SAVE_BRANCH_ORG : API_HOST + "/api/grp/saveBranchOrg.do",          //"branchId""memberNo""erectDate"는 필수값으로 , 수정도 동일 API 사용 필수값은 최초 저장후 변경 못함.
                                                                    // "reign","positionCd","remark"은 옵션으로 저장.

  DELETE_BRANCH_ORG : API_HOST + "/api/grp/removeBranchOrg.do",   // "branchId""memberNo""erectDate"는 필수값 정보 넘겨서 호출

  GET_BRANCH_ORG : API_HOST + "/api/grp/getBranchOrgList.do",   //  검색 조건값 : branchGb / branchNm / positionCd / bornCd

  GROUP_EXECUTIVE_EXCEL_DOWNLOAD : API_HOST + "/api/grp/groupExectiveExcelDownload.do",   
  ////////////////////////////////////////////////////////////////////////////
  // 행사 관리
  ///////////////////////////////////////////////////////////////////////////

  // 행사관리 //////////////////////////////////////////////////////////////////////
  GET_EVENT_INFO_LIST: API_HOST + "/api/evt/getEventInfoList.do",         // 행사내역 조회
  EVENT_INFO_EXCEL_DOWNLOAD: API_HOST + "/api/evt/eventInfoExcelDownload.do",         // 행사내역 조회
  
  SAVE_EVENT_INFO: API_HOST + "/api/evt/saveEventInfo.do",                // 행사일정 등록/수정
  SAVE_EVENT_INFO_LIST: API_HOST + "/api/evt/saveEventInfoList.do",       // 행사일정 등록/수정
  SAVE_EVENT_JOINER: API_HOST + "/api/evt/saveEventJoiner.do",            // 행사참가자 등록/수정
  SAVE_EVENT_JOINER_LIST: API_HOST + "/api/evt/saveEventJoinerList.do",   // 행사참가자 등록/수정 | 배열로 전송
  UPDATE_EVENT_JOINER: API_HOST + "/api/evt/updateEventJoiner.do",            // 행사참가자 등록/수정

  GET_EVENT_JOINER_LIST2: API_HOST + "/api/evt/getEventJoinerList.do",     // 행사참여자 조회 by eventId, 필수파라미터 : eventId
  EVENT_JOINER_EXCEL_DOWNLOAD: API_HOST + "/api/evt/eventJoinerExcelDownload.do",         // 행사내역 조회
  
  // 옵셔널파라미터 : outjoinerGb, memberNo, seqNo
  EVENT_REPLY_EXCEL_DOWNLOAD: API_HOST + "/api/evt/eventReplyExcelDownload.do",     // 행사참여자 엑셀 다운로드
  INFO_REPLY_EXCEL_DOWNLOAD: API_HOST + "/api/evt/infoReplyExcelDownload.do",     // 행사참여자 엑셀 다운로드
  DELETE_EVENT_JOINER : API_HOST + "/api/evt/deleteEventJoiner.do", //행사참가자 삭제 , 필수파라미터 seqNo, event_id
  DELETE_EVENT_JOINER2 : API_HOST + "/api/evt/deleteEventJoinerList.do", //행사참가자 삭제 , 필수파라미터 seqNo, event_id | 배열로 전송

  //4-2 경조사관리
  GET_PRIZE_LIST : API_HOST + "/api/aln/getPrizeList.do",
  SAVE_PRIZE : API_HOST + "/api/aln/savePrize.do",
  UPDATE_PRIZE : API_HOST + "/api/aln/updatePrize.do",
  DELETE_PRIZE : API_HOST + "/api/aln/removePrize.do",
  PRIZE_EXCEL_DOWNLOAD : API_HOST + "/api/aln/prizeExcelDownload.do",
  
  //4-3,4 응답관리
  GET_ANSWER_ATTEND_LIST : API_HOST + "/api/evt/getAnswerAttendList.do",
  DELETE_ANSWER_ATTEND_LIST : API_HOST + "/api/evt/removeAnswerAttendList.do",
  
  GET_ANSWER_CHANGE_LIST : API_HOST + "/api/evt/getAnswerChangeList.do",
  DELETE_ANSWER_CHANGE_LIST : API_HOST + "/api/evt/removeAnswerChangeList.do",





  ////////////////////////////////////////////////////////////////////////////
  // 운영 관리
  ///////////////////////////////////////////////////////////////////////////

  // 사용자관리 //////////////////////////////////////////////////////////////////////
  //GET_USER_LIST: API_HOST + "/api/opr/getUserList.do",  캠페인 분배관련 재사용
  SAVE_USER: API_HOST + "/api/opr/saveUser.do",
  
  GET_USER_INFO: API_HOST + "/api/auth/getUserInfo.do",
  CHANGE_USER_INFO: API_HOST + "/api/auth/modifyUserInfo.do",
  CHANGE_USER_PASSWD: API_HOST + "/api/auth/changeUserPasswd.do",
  GET_USER_CONNECT_LIST: API_HOST + "/api/auth/getUserConnectHisList.do",

  // 권한관리 //////////////////////////////////////////////////////////////////////
  GET_MENU_LIST: API_HOST + "/api/opr/getMenuList.do",
  GET_MENU_GRP_LIST: API_HOST + "/api/opr/getMenuGrpList.do",
  GET_MENU_GRP_MENU_LIST: API_HOST + "/api/opr/getMenuGrpMenuMapList.do",
  SAVE_MENU_LIST: API_HOST + "/api/opr/saveMenuList.do",
  SAVE_MENU: API_HOST + "/api/opr/saveMenu.do",
  SAVE_MENU_GRP: API_HOST + "/api/opr/saveMenuGrp.do",
  SAVE_MENU_GRP_MENU_LIST: API_HOST + "/api/opr/saveMenuGrpMenuMapList.do",
  DELETE_MENU_GRP_MENU: API_HOST + "/api/opr/deleteMenuGrpMenuMap.do",
  
  // 코드관리 //////////////////////////////////////////////////////////////////////
  GET_CODE_GRP_LIST: API_HOST + "/api/opr/getCodeGrpList.do",
  GET_CODE_L_LIST: API_HOST + "/api/opr/getCodeLList.do",
  GET_CODE_M_LIST: API_HOST + "/api/opr/getCodeMList.do",
  GET_CODE_S_LIST: API_HOST + "/api/opr/getCodeSList.do",
  SAVE_CODE_GRP_LIST: API_HOST + "/api/opr/saveCodeGrpList.do",
  SAVE_CODE_L_LIST: API_HOST + "/api/opr/saveCodeLList.do",
  SAVE_CODE_M_LIST: API_HOST + "/api/opr/saveCodeMList.do",
  SAVE_CODE_S_LIST: API_HOST + "/api/opr/saveCodeSList.do",
  DELETE_CODE_GRP_LIST: API_HOST + "/api/opr/deleteCodeGrpList.do",
  DELETE_CODE_L_LIST: API_HOST + "/api/opr/deleteCodeLList.do",
  DELETE_CODE_M_LIST: API_HOST + "/api/opr/deleteCodeMList.do",
  DELETE_CODE_S_LIST: API_HOST + "/api/opr/deleteCodeSList.do",
  GET_CPN_LIST: API_HOST + "/api/opr/getCompanyList.do",    // 직장목록
  SAVE_CPN_LIST: API_HOST + "/api/opr/saveCompanyList.do",  // 직장저장

  GET_BOARD_LIST : API_HOST + "/api/opr/getBoardList.do",
  SAVE_BOARD : API_HOST + "/api/opr/saveBoard.do",
  UPDATE_BOARD : API_HOST + "/api/opr/updateBoard.do",
  DELETE_BOARD : API_HOST + "/api/opr/deleteBoard.do",

  // tb_consult 상담테이블
  GET_CONSULT_LIST: API_HOST + "/api/cst/getConsultList.do",
  DELETE_CONSULT: API_HOST + "/api/cst/deleteConsult.do",

  // tb_cmp_result 캠페인 대상자 정보 테이블
  GET_CMP_RESULT_LIST: API_HOST + "/api/cst/getCmpResultList.do",       // {    "cCmpId" : "CMP20201021121351"}
  GET_CMP_RESULT_COUNT_LOG: API_HOST + "/api/cst/getCmpResultCountLog.do",       // {    "cCmpId" : "CMP20201021121351"}
  
  GET_CMP_CALL_RESULT_COUNT_LOG: API_HOST + "/api/cst/getCmpCallResultCountLog.do",       // {    "cCmpId" : "CMP20201021121351"}
  GET_CMP_CALL_RESULT_COUNT_TOTAL_LOG: API_HOST + "/api/cst/getCmpCallResultTotalCountLog.do",       // {    "cCmpId" : "CMP20201021121351"}
  GET_CMP_DATE_RESULT_COUNT_LOG: API_HOST + "/api/cst/getCmpDateResultCountLog.do",       // {    "cCmpId" : "CMP20201021121351"}
  GET_CMP_DISTRIBUTION_LIST: API_HOST + "/api/cst/getCmpDistributionList.do",     // 상담사(cAgentId)와 할당된 숫자(distCnt), 캠페인 아이디(cCmpId), 캠페인 고객그룹아이디(cCustGrpId)를 전달, 배열 첫 row에 캠페인콜사용 코드(calluseCd) 넣기.

  CMP_RESULT_EXCEL_DOWNLOAD: API_HOST + "/api/cst/cmpResultExcelDownload.do",       // {    "cCmpId" : "CMP20201021121351"}
  
  SAVE_CMP_RESULT: API_HOST + "/api/cst/saveCmpResult.do",
  SAVE_CMP_RESULT_LIST: API_HOST + "/api/cst/saveCmpResultList.do",     // [{    "cCmpId" : "CMP20201021121351","cCustGrpId" : "20201021121351","cCustId" : "K0000081"}]
  DELETE_CMP_RESULT: API_HOST + "/api/cst/deleteCmpResult.do",          // 
  REMOVE_CMP_RESULT_LIST: API_HOST + "/api/cst/removeCmpResultList.do", // [{    "cCmpId" : "CMP20201021121351","cCustGrpId" : "20201021121351","cCustId" : "K0000981"},{    "cCmpId" : "CMP20201021121351", "cCustGrpId" : "20201021121351",    "cCustId" : "K0000982"}]

  MODIFY_CMP_RESULT_STATUS_LIST: API_HOST + "/api/cst/modifyCmpResultStatusList.do",     // 캠페인 전화 결과를 저장함. cCmpId,cCustGrpId, cCustId, result, callResult, remark를 배열로 담아 넘김.

  // tb_cmp_preview 캠페인 정보 테이블
  SAVE_CMP_PREVIEW: API_HOST + "/api/cst/saveCmpPreview.do",            // {    "cCustGrpNm" : "캠페인테스트",    "cCustGrpDesc" : "캠패인설명"}
  GET_CMP_PREVIEW: API_HOST + "/api/cst/getCmpPreviewList.do",          // {    "cCustGrpNm" : "테스트"} 검색어 지정시 검색, 없으면 전체 목록. cAgentId 값을 넣으면, 상담사에 배정된 목록만 검색됨
  MODIFY_CMP_PREVIEW: API_HOST + "/api/cst/modifyCmpPreview.do",        // {    "cCustGrpNm" : "",    "cCustGrpDesc" : "",    "cCmpId" : "",    "cCustGrpId" : ""}


  // 캠페인 분배 관련API_HOST + "/api/cst/getCmpPreviewList.do"
  GET_USER_LIST: API_HOST + "/api/opr/getUserList.do",                  // {    "userRight" : "1"}  
  DIST_CMP_RESULT_LIST: API_HOST + "/api/cst/distCmpResultAgentIdList.do",     // 상담사(cAgentId)와 할당된 숫자(distCnt), 캠페인 아이디(cCmpId), 캠페인 고객그룹아이디(cCustGrpId)를 전달, 배열 첫 row에 캠페인콜사용 코드(calluseCd) 넣기.

  // tb_ocrlist
  GET_OCR_LIST: API_HOST + "/api/aln/getMemberOcrList.do",
  SAVE_OCR: API_HOST + "/api/opr/saveOcr.do",
  DELETE_OCR: API_HOST + "/api/opr/deleteOcr.do",
  OCR_EXCEL_DOWNLOAD: API_HOST + "/api/aln/ocrExcelDownload.do",


  GET_DASHBOARD_STATISTICS_INFO : API_HOST +"/api/opr/getDashboardStatisticsInfo.do",
  GET_DASHBOARD_SCHA_INFO : API_HOST +"/api/scm/getDashboardSchaInfo.do",
  //공통 / 팝업 ////////////////////////////////////////////////////////

// 역대회장단 관리
  GET_PRESIDENCY_INFO_LIST: API_HOST + "/api/aln/getPresidencyInfoList.do",   //"presidencyCd" : "02"
  SAVE_PRESIDENCY_INFO: API_HOST + "/api/aln/savePresidencyInfo.do",
  UPDATE_PRESIDENCY_INFO: API_HOST + "/api/aln/modifyPresidencyInfo.do",
  DELETE_PRESIDENCY_INFO: API_HOST + "/api/aln/removePresidencyInfo.do",

  GET_PRESIDENCY_SCHA_LIST: API_HOST + "/api/aln/getPresidencySchaList.do",   //"presidencyCd" : "02"
  SAVE_PRESIDENCY_SCHA: API_HOST + "/api/aln/savePresidencySchaList.do",
  UPDATE_PRESIDENCY_SCHA: API_HOST + "/api/aln/modifyPresidencyScha.do",
  DELETE_PRESIDENCY_SCHA: API_HOST + "/api/aln/removePresidencySchaList.do",

  GET_PRESIDENCY_BRD_LIST: API_HOST + "/api/aln/getPresidencyBrdList.do",     //"presidencyCd" : "02" , "PresiLevelCd" : "02"
  SAVE_PRESIDENCY_BRD: API_HOST + "/api/aln/savePresidencyBrdList.do",
  UPDATE_PRESIDENCY_BRD: API_HOST + "/api/aln/modifyPresidencyBrd.do",
  DELETE_PRESIDENCY_BRD: API_HOST + "/api/aln/removePresidencyBrdList.do",

  PRESIDENCY_BRD_EXCEL_DOWNLOAD: API_HOST + "/api/aln/presidencyBrdExcelDownload.do",

  PRESIDENCY_SCHA_EXCEL_DOWNLOAD: API_HOST + "/api/aln/presidencySchaExcelDownload.do",

 // DELETE_ADDR_HIS: API_HOST + "/api/cmm/deleteAddrHis.do",

  // 장학관리

  GET_SCHA_DONOR_LIST : API_HOST +"/api/aln/getSchaDonorList.do",
  SAVE_SCHA_DONOR_LIST : API_HOST +"/api/aln/saveSchaDonor.do",
  DELETE_SCHA_DONOR_LIST : API_HOST +"/api/aln/deleteSchaDonor.do",

  GET_SCHA_APPLY_LIST : API_HOST +"/api/scm/getSchaApplyList.do",
  GET_SCHA_APPLY_LIST2 : API_HOST +"/api/scm/getSchaMappingList2.do", //장학매칭 관리
  SAVE_SCHA_APPLY : API_HOST +"/api/scm/saveSchaApply.do",
  SAVE_SCHA_APPLY_LIST : API_HOST +"/api/scm/saveSchaApplyList.do",
  UPDATE_SCHA_APPLY : API_HOST +"/api/scm/updateSchaApply.do",
  UPDATE_SCHA_APPLY_ONE : API_HOST +"/api/scm/updateSchaApplyOne.do",
  DELETE_SCHA_APPLY_LIST : API_HOST +"/api/scm/removeSchaApply.do",
  DELETE_SCHA_APPLY_LIST2 : API_HOST +"/api/scm/removeSchaApplyList.do",
  FILE_DELTE : API_HOST +"/api/scm/deleteFile.do",

  SCHA_APPLY_MAPPING_EXCEL_DOWNLOAD2 : API_HOST + "/api/scm/schaMappingListExcelDownload2.do",

  GET_SCHA_APPLY_GOTS_LIST : API_HOST + "/api/scm/getSchaApplyGotsList.do",
  SAVE_SCHA_APPLY_GOTS : API_HOST + "/api/scm/saveSchaApplyGots.do",
  SAVE_SCHA_APPLY_GOTS_LIST : API_HOST + "/api/scm/saveSchaApplyGotsList.do",
  UPDATE_SCHA_APPLY_GOTS : API_HOST + "/api/scm/updateSchaApplyGots.do",
  UPDATE_SCHA_APPLY_GOTS_LIST : API_HOST + "/api/scm/updateSchaApplyGotsList.do",
  DELETE_SCHA_APPLY_GOTS : API_HOST + "/api/scm/removeSchaApplyGots.do",
  DELETE_SCHA_APPLY_GOTS_LIST : API_HOST + "/api/scm/removeSchaApplyGotsList.do",
  
  GET_SCHA_APPLY_FAMILY_LIST : API_HOST + "/api/scm/getSchaApplyFamilyList.do",
  SAVE_SCHA_APPLY_FAMILY : API_HOST + "/api/scm/saveSchaApplyFamily.do",
  SAVE_SCHA_APPLY_FAMILY_LIST : API_HOST + "/api/scm/saveSchaApplyFamilyList.do",
  UPDATE_SCHA_APPLY_FAMILY : API_HOST + "/api/scm/updateSchaApplyFamily.do",
  UPDATE_SCHA_APPLY_FAMILY_LIST : API_HOST + "/api/scm/updateSchaApplyFamilyList.do",
  DELETE_SCHA_APPLY_FAMILY : API_HOST + "/api/scm/removeSchaApplyFamily.do",
  DELETE_SCHA_APPLY_FAMILY_LIST : API_HOST + "/api/scm/removeSchaApplyFamilyList.do",
  
  GET_SCHA_MAPPING_RESOURCE : API_HOST + "/api/scm/getSchaMappingResourceList.do",
  GET_SCHA_MAPPING_LIST : API_HOST + "/api/scm/getSchaMappingList.do",
  SAVE_SCHA_MAPPING : API_HOST + "/api/scm/saveSchaMapping.do",
  SAVE_SCHA_ATTEND : API_HOST + "/api/scm/saveSchaAttend.do",
  DELETE_SCHA_MAPPING_LIST : API_HOST + "/api/scm/deleteSchaMappingList.do",
  DELETE_SCHA_MAPPING : API_HOST + "/api/scm/deleteSchaMapping.do",

  GET_TUITION_LIST : API_HOST +"/api/scm/getTuitionList.do",
  SAVE_TUITION_LIST : API_HOST +"/api/scm/saveTuitionList.do",
  UPDATE_TUITION : API_HOST +"/api/scm/updateTuition.do",
  DELETE_TUITION_LIST : API_HOST +"/api/scm/deleteTuitionList.do",

  GET_SCHA_HOME_RE : API_HOST +"/api/scm/getSchaHomeReList.do", 
  SAVE_SCHA_HOME_RE_LIST : API_HOST +"/api/scm/saveSchaHomeReList.do",
  DELETE_SCHA_HOME_RE : API_HOST +"/api/scm/deleteSchaHomeRe.do",
  
  GET_SCHA_APPLY_STATUS : API_HOST +"/api/scm/getSchaApplyStatus.do", 
  UPDATE_SCHA_APPLY_STATUS : API_HOST +"/api/scm/updateSchaApplyStatus.do",
  
  SCHA_APPLY_EXCEL_DOWNLOAD: API_HOST + "/api/scm/schaApplyExcelDownload.do",
  SCHA_APPLY_MAPPING_EXCEL_DOWNLOAD: API_HOST + "/api/scm/schaApplyMappingExcelDownload.do",
  SCHA_APPLY_DONOR_EXCEL_DOWNLOAD: API_HOST + "/api/aln/schaApplyDonorExcelDownload.do",


  UPDATE_SCHA_APPLY_MEMBER_NO : API_HOST +"/api/scm/updateApplyMemberNo.do",    // 장학금 수혜자 교우번호 갱신
  GET_STATISTICS_SCHA_LIST : API_HOST +"/api/scm/getStatisticsSchaList.do",

  SAVE_DONOR_CONTACT_HISTORY : API_HOST +"/api/scm/saveSchaDonorContact.do", // 장학금 기부자 주요변동사항 이력 저장
  GET_DONOR_CONTACT_HISTORY : API_HOST +"/api/scm/getSchaDonorContactList.do", // 장학금 기부자 주요변동사항 이력 조회
  DELETE_SCHA_DONOR_CONTACT : API_HOST +"/api/scm/deleteSchaDonorContact.do", // 장학금 기부자 주요변동사항 이력 삭제

};
export default URL_CONST;
